import { Tab, Tabs } from '@decisiv/ui-components';
import React from 'react';
import PropTypes from 'prop-types';
import CurrentAccess from './components/CurrentAccess';
import RemovedAccess from './components/RemovedAccess';
import { CssResetStyle } from '../AssociatedLocations/components/styledComponents';

const Users = ({
  dealerId,
  isGlobalAdmin,
  renderedPartial,
  csrfToken,
  isFleet,
  availableSsoProviders,
  ssoProviderLabels,
  ssoFeatureEnabled,
}) => {
  return (
    <>
      <CssResetStyle />

      <Tabs defaultSelectedId="current-access" onChange={showOrHideUsersDiv}>
        <Tab id="current-access" title="Current Access">
          <CurrentAccess
            dealerId={dealerId}
            isGlobalAdmin={isGlobalAdmin}
            csrfToken={csrfToken}
            isFleet={isFleet}
            availableSsoProviders={availableSsoProviders}
            ssoProviderLabels={ssoProviderLabels}
            ssoFeatureEnabled={ssoFeatureEnabled}
          />
        </Tab>
        <Tab id="removed-access" title="Removed Access">
          <RemovedAccess dealerId={dealerId} isFleet={isFleet} />
        </Tab>
        {isGlobalAdmin && (
          <Tab id="supported" title="Supported/Watched By">
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: renderedPartial }}
            />
          </Tab>
        )}
      </Tabs>
    </>
  );
};

const showOrHideUsersDiv = (selectedTab) => {
  const externalDiv = document.getElementById('user_find_or_create_form');
  if (externalDiv) {
    externalDiv.style.display =
      selectedTab === 'current-access' ? 'block' : 'none';
  }
};

Users.propTypes = {
  dealerId: PropTypes.number.isRequired,
  isGlobalAdmin: PropTypes.bool.isRequired,
  renderedPartial: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  isFleet: PropTypes.bool.isRequired,
  availableSsoProviders: PropTypes.shape({
    providers: PropTypes.arrayOf(PropTypes.string),
    require_sso: PropTypes.bool,
  }),
  ssoProviderLabels: PropTypes.objectOf(PropTypes.string),
  ssoFeatureEnabled: PropTypes.bool,
};

Users.defaultProps = {
  availableSsoProviders: {
    providers: [],
    require_sso: false,
  },
  ssoProviderLabels: {},
  ssoFeatureEnabled: false,
};

export default Users;
